//Reset data
export const RESET = "PROFIL_UPDATE_RESET"

export const SET_IS_UPDATED = "PROFIL_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "PROFIL_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "PROFIL_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "PROFIL_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "PROFIL_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "PROFIL_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "PROFIL_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "PROFIL_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "PROFIL_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "PROFIL_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "PROFIL_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "PROFIL_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "PROFIL_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "PROFIL_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "PROFIL_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "PROFIL_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "PROFIL_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "PROFIL_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "PROFIL_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "PROFIL_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "PROFIL_UPDATE_SET_MODAL_TYPE"